import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

import { router } from '@/app/router'
import { queryClient } from '@/shared/api/queryClient'
import { ThemeProvider } from '@/shared/theme/ThemeContext'
import CookieConsentBanner from '@/shared/ui/CookieConsentBanner'

export default function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <CookieConsentBanner />
      </QueryClientProvider>
    </ThemeProvider>
  )
}
